import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { AboutUs, AppSettings, Faqs, MobileAppMenus, PrivacyPolicy, Toc, VehicleManual, } from './sub-pages';

const ContentMangement = () => {
  const [activeTab, setActiveTab] = useState('1');

  return (
    <>
      <Nav tabs>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '1' ? 'active' : ''}`} onClick={() => setActiveTab('1')}>FAQ's</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '2' ? 'active' : ''}`} onClick={() => setActiveTab('2')}>About Us</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '3' ? 'active' : ''}`} onClick={() => setActiveTab('3')}>Privacy Policy</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '4' ? 'active' : ''}`} onClick={() => setActiveTab('4')}>Terms & Conditions</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '5' ? 'active' : ''}`} onClick={() => setActiveTab('5')}>Mobile App Settings</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '6' ? 'active' : ''}`} onClick={() => setActiveTab('6')}>Mobile App Menus</NavLink>
        </NavItem>
        <NavItem className='cursor-pointer'>
          <NavLink className={`text-sm ${activeTab === '7' ? 'active' : ''}`} onClick={() => setActiveTab('7')}>Vehicle Manual</NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab} className="border border-top-0 p-3 mt-2 bg-white">
        <TabPane tabId="1"><Faqs/></TabPane>
        <TabPane tabId="2"><AboutUs/></TabPane>
        <TabPane tabId="3"><PrivacyPolicy/></TabPane>
        <TabPane tabId="4"><Toc/></TabPane>
        <TabPane tabId="5"><AppSettings/></TabPane>
        <TabPane tabId="6"><MobileAppMenus/></TabPane>
        <TabPane tabId="7"><VehicleManual/></TabPane>
      </TabContent>
    </>
  );
};

export default ContentMangement;
